// Zalo OAuth v4 helpers ("Đăng nhập với Zalo") — front-channel PKCE.
// The SPA generates a code_verifier + S256 challenge, sends the child to
// oauth.zaloapp.com, then the callback page exchanges the returned code via
// our backend (which holds the app secret).

const ZALO_AUTHORIZE_URL = 'https://oauth.zaloapp.com/v4/permission';

const b64url = (bytes) =>
  btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

const randomString = (len = 43) => {
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  return b64url(bytes).slice(0, len);
};

export const zaloRedirectUri = () => `${window.location.origin}/auth/zalo/callback`;

// Generates PKCE material, stashes it in sessionStorage and returns the
// authorize URL to redirect to.
export async function buildZaloAuthorizeUrl(appId) {
  const verifier = randomString(43);
  const state = randomString(24);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const challenge = b64url(digest);

  sessionStorage.setItem('zalo_code_verifier', verifier);
  sessionStorage.setItem('zalo_state', state);

  const params = new URLSearchParams({
    app_id: appId,
    redirect_uri: zaloRedirectUri(),
    code_challenge: challenge,
    code_challenge_method: 'S256',
    state,
  });
  return `${ZALO_AUTHORIZE_URL}?${params.toString()}`;
}

export function consumeZaloPkce(returnedState) {
  const verifier = sessionStorage.getItem('zalo_code_verifier');
  const state = sessionStorage.getItem('zalo_state');
  sessionStorage.removeItem('zalo_code_verifier');
  sessionStorage.removeItem('zalo_state');
  if (!verifier || !state || state !== returnedState) return null;
  return verifier;
}
